/**
 * * Utility to handle include mobile number and url in post ad
 *
 * @author John Lukose <john.lukose@quikr.com>
 */

import Config from '../../Config';
import CookieHelper from '../../Apply/ApplyCookieHelper';

export class IncludeWebsiteUrl {
	//static details for initial load. These get updated on getting context
	static priceDetails = {
		amount:  99,
		credits: 3
	};

	static isEnabled = (store) => {
		let isEnabled = false;
		if (Config.hasKey('jobsPostAdMonetizationFeatureEnabledAbRandValues', store)) {
			let enabledValues = Config.get('jobsPostAdMonetizationFeatureEnabledAbRandValues', store);
			if (('undefined' !== typeof enabledValues) && ('' !== enabledValues)) {
				let cookieHelper = new CookieHelper();
				let abRandValue = cookieHelper.getABRandMobile();
				isEnabled = (-1 !== enabledValues.indexOf(abRandValue));
			}
		}
		return isEnabled;
	};

	static getPrice = type => (
		('credit' === type) ? IncludeWebsiteUrl.priceDetails.credits : IncludeWebsiteUrl.priceDetails.amount
	);

	static setPrice = (type, price) => {
		let field = (('credit' === type) ? 'credits' : 'amount');
		IncludeWebsiteUrl.priceDetails[field] = price;
	};

	static updatePrice = (store) => {
		let jobsPostAdMonetizationFeaturePrices = Config.get('jobsPostAdMonetizationFeaturePrices', store);
		if ('undefined' !== typeof jobsPostAdMonetizationFeaturePrices) {
			IncludeWebsiteUrl.setPrice('money', jobsPostAdMonetizationFeaturePrices.includeWebsiteUrl);
			IncludeWebsiteUrl.setPrice('credit', jobsPostAdMonetizationFeaturePrices.includeWebsiteUrlCredit);
		}
	};
}

export class IncludeMobileNumber {
	//static details for initial load. These get updated on getting context
	static priceDetails = {
		amount:  99,
		credits: 3
	};

	static isEnabled = (store) => {
		let isEnabled = false;
		if (Config.hasKey('jobsPostAdMonetizationFeatureEnabledAbRandValues', store)) {
			let enabledValues = Config.get('jobsPostAdMonetizationFeatureEnabledAbRandValues', store);
			if (('undefined' !== typeof enabledValues) && ('' !== enabledValues)) {
				let cookieHelper = new CookieHelper();
				let abRandValue = cookieHelper.getABRandMobile();
				isEnabled = (-1 !== enabledValues.indexOf(abRandValue));
			}
		}
		return isEnabled;
	};

	static getPrice = type => (
		('credit' === type) ? IncludeMobileNumber.priceDetails.credits : IncludeMobileNumber.priceDetails.amount
	);

	static setPrice = (type, price) => {
		let field = (('credit' === type) ? 'credits' : 'amount');
		IncludeMobileNumber.priceDetails[field] = price;
	};

	static updatePrice = (store) => {
		let jobsPostAdMonetizationFeaturePrices = Config.get('jobsPostAdMonetizationFeaturePrices', store);
		if ('undefined' !== typeof jobsPostAdMonetizationFeaturePrices) {
			IncludeMobileNumber.setPrice('money', jobsPostAdMonetizationFeaturePrices.includeMobileNumber);
			IncludeMobileNumber.setPrice('credit', jobsPostAdMonetizationFeaturePrices.includeMobileNumberCredit);
		}
	};
}



// WEBPACK FOOTER //
// ../q-jobs/src/utils/JobsPostAd/others/includeMobileUrl.js